// components/chat-surface/chat-scroll-engine.js
// ═══════════════════════════════════════════════════════════
// Scroll container with auto-scroll, scroll-to-bottom button,
// and thin blended scrollbar. Drop-in wrapper for any message list.
//
// Usage:
//   <ChatScrollEngine
//     scrollContainerRef={ref}
//     lastUserMsgRef={ref}
//     spacerRef={ref}
//     showScrollBtn={bool}
//     onScrollToBottom={fn}
//   >
//     {children}
//   </ChatScrollEngine>
// ═══════════════════════════════════════════════════════════

export default function ChatScrollEngine({
  scrollContainerRef,
  lastUserMsgRef,
  spacerRef,
  showScrollBtn,
  onScrollToBottom,
  children,
}) {
  return (
    <>
      <style jsx global>{`
        .chat-surface-scroll::-webkit-scrollbar {
          width: 4px;
        }
        .chat-surface-scroll::-webkit-scrollbar-track {
          background: transparent;
        }
        .chat-surface-scroll::-webkit-scrollbar-thumb {
          background: #1e1e2a;
          border-radius: 4px;
        }
        .chat-surface-scroll::-webkit-scrollbar-thumb:hover {
          background: #2a2a2a;
        }
      `}</style>

      <div
        ref={scrollContainerRef}
        className="chat-surface-scroll"
        style={{
          flex: 1,
          overflowY: 'auto',
          overflowX: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          scrollBehavior: 'smooth',
        }}
      >
        {children}
        <div ref={spacerRef} style={{ height: 0, flexShrink: 0 }} aria-hidden="true" />
      </div>

      {/* Scroll-to-bottom button */}
      {showScrollBtn && (
        <div style={{
          height: 38,
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#07070a',
          borderTop: '1px solid #1e1e2a',
        }}>
          <button
            onClick={onScrollToBottom}
            style={{
              width: 32, height: 32, borderRadius: '50%',
              background: '#141414', border: '1px solid #2a2a2a',
              cursor: 'pointer', display: 'flex',
              alignItems: 'center', justifyContent: 'center',
              transition: 'border-color 0.15s, background 0.15s',
            }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(200,169,110,0.4)'; e.currentTarget.style.background = '#1e1e2a'; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = '#2a2a2a'; e.currentTarget.style.background = '#141414'; }}
          >
            <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
              <path d="M8 3v10M4 9l4 4 4-4" stroke="#c8a96e" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>
      )}
    </>
  );
}
